import styled from '@emotion/styled';
import { Button, Modal as ModalBase } from '@ui-components/neo.tax';

export const Modal = styled(ModalBase)({
  maxWidth: '515px',
  width: '100%',
});

export const StyledActionButton = styled(Button)({
  display: 'inline-block',
  textAlign: 'center',
  width: '100%',
});
